$( document ).ready(function() {
  'use strict';

	var hamburgers = document.querySelectorAll(".hamburger");
	
	$(hamburgers).on('click', function () {
    	$('.js-menu').animate({
            'display': 'block',
    		'left': 0
    	},300);
        $('.menu--color').removeClass('hidden');
    	$('body').addClass('no-scroll');
    	$(this).closest('.section').addClass('menu-scroll');
	});
});





